<template>
  <div class="adminUserList">
    <div class="row">
      <div class="col-md-5">
        <Breadcumb title="Liste des utilisateurs" :breadcumb-data="breadcumbData">
          <b-btn v-bind:to="'/dashboard/administration/user/add/'" class="mt-3 mb-3" variant="primary" style="float:right">
            Inviter un utilisateur
          </b-btn>
        </Breadcumb>
      </div>
    </div>
    <b-card no-body class="mb-3 cardcontainer">
      <b-card-body>
        <b-form inline class="" @submit="searchUser">
          <b-input class="mr-sm-2 mb-sm-0" placeholder="Nom" v-model="lastname" />
          <b-input class="mr-sm-2 mb-sm-0" placeholder="Prénom" v-model="firstname" />
          <b-input class="mr-sm-2  mb-sm-0" placeholder="Email" v-model="email" />
          <b-input class="mr-sm-2 mb-sm-0" placeholder="Filiale" v-model="company" />
          <b-select class="custom-select mr-sm-2  mb-sm-0" v-model="user_type" value="Niveau d'accès..." :options=userTypeData />
          <b-btn type="submit" variant="primary">Rechercher</b-btn>
          <b-btn v-on:click="resetSearch" variant="default" class="ml-1"><i class="ion ion-md-close"></i></b-btn>
        </b-form>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-body>
        <b-table
                v-if="usersData"
                :items="usersData"
                :fields="fields"
                :striped="true"
                :bordered="true"
                class="card-table">

          <template slot="Email" slot-scope="data">
            {{data.item.email}}
          </template>
          <template slot="Nom" slot-scope="data">
            <span v-if="data.item.userprofile">{{data.item.userprofile.lastname }}</span>
          </template>
          <template slot="Prénom" slot-scope="data">
            <span v-if="data.item.userprofile">{{data.item.userprofile.firstname }}</span>
          </template>
          <template slot="Dernière connexion" slot-scope="data"> {{ data.item.last_connection|formatDateNoH }}</template>
          <template slot="status" slot-scope="data">
            <b-badge variant="outline-success" v-if="data.item.status === 'ACT'">Actif</b-badge>
            <b-badge variant="outline-default" v-if="data.item.status === 'INV'">Invité</b-badge>
            <b-badge variant="outline-danger" v-if="data.item.status === 'DEA'">Désactivé</b-badge>
          </template>
          <template slot="Actions" slot-scope="data">
            <b-btn v-bind:to="'/dashboard/administration/user/' + data.item.id" variant="default btn-xs icon-btn md-btn-flat"
                   v-b-tooltip.hover title="Profil"><i class="ion ion-md-person"></i></b-btn>
            <b-btn v-on:click="deleteId= data.item.id; $refs.formodal.open()" variant="default btn-xs md-btn-flat">
              <i class="ion ion-md-close"></i>
            </b-btn>
          </template>
          <template slot="Niveau d'accès" slot-scope="data">
            <span v-if="data.item.userprofile">
              <template>{{ data.item.userprofile.user_type.label }}</template>
            </span>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <sweet-modal width="300px" ref="formodal" height="80%">
      <b-btn v-on:click="deleteUser(deleteId)" variant="danger md-btn-flat"
             v-b-tooltip.hover title="Supprimer">Supprimer l'utilisateur</b-btn>
    </sweet-modal>
  </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<script>
  import {
    ADMIN_GET_USERS_REQUEST,
    ADMIN_DELETE_USER_REQUEST,
    ADMIN_GET_USERTYPES_REQUEST
  } from '../../_store/administration/user/actiontypes';
  import Breadcumb from '../../components/breadcumb';
  import { mapState } from 'vuex';
  import {SweetModal, SweetModalTab} from 'sweet-modal-vue'
  
  export default {
    name: 'adminUserList',
    components: {Breadcumb, SweetModal, SweetModalTab},
    computed: mapState({ usersData: state => state.admin_user.users }),
    mounted() {
      this.$store.dispatch(ADMIN_GET_USERS_REQUEST)
    },
    methods: {
      resetSearch(){
        this.lastname = null;
        this.firstname = null;
        this.email = null;
        this.$store.dispatch(ADMIN_GET_USERS_REQUEST, {});
      },
      searchUser: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_GET_USERS_REQUEST, {
          lastname: this.lastname,
          firstname: this.firstname,
          email: this.email,
        })
      },
      deleteUser(id) {
        this.$store.dispatch(ADMIN_DELETE_USER_REQUEST, id)
          .then(() => {
            this.$router.push('/dashboard/administration/userlist/');
            this.$refs.formodal.close();
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    data() {
      return {
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des utilisateurs', active: true },
        ],
        dataUrl: 'json/pages_users_list.json',
        searchKeys: [],
        sortBy: 'id',
        sortDesc: false,
        perPage: 10,
        deleteId: false,
        lastname: null,
        firstname: null,
        email: null,
        userTypeData: [],
        company: null,
        user_type: null,
        fields: [
          {
            key: 'Nom',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Prénom',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Email',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'status',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Dernière connexion',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Niveau d\'accès',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Actions',
            sortable: false,
            tdClass: 'align-middle'
          }
        ],

        // Filters
        filterVerified: 'Any',
        filterRole: 'Any',
        filterStatus: 'Any',
        filterLatestActivity: null,

        originalUsersData: [],
        currentPage: 1
      };
    },
    layout(context) {
      return 'layout';
    },
  };
</script>
